import UserCertificationItem from './UserCertificationItem';
import { ICertifications } from '@/lib/interface.ts';

export default UserCertificationItem;

export interface IHasCertification {
  certification: ICertifications;
}
